import _ from 'lodash'
import React from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../variables/config';
import { sendRequest } from '../../modules/admin'
import { newUser, changeFinished, newUserNotRequired } from '../../modules/users'
import './register.scss'
import Webcam from "react-webcam";
import Alert from '../views/alert';
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import { isBlank } from '../helpers/validation';

const registerText = 'Register User';
const firstNameText = 'First name';
const lastNameText = 'Last name';
const emailText = 'Email';
const addressOneText = 'Address 1';
const addressTwoText = 'Address 2';
const cityText = 'City';
const countryText = 'Country';
const postcodeText = 'Postcode';
const phoneText = "Phone number";
const countyText = "County";
const submitText = "Submit";
const tryAgainText = "Please try again later";
const errorText = "Error";
const loadingText = "Loading";
const takePictureText = "Take Picture";
const takeAgainText = "Take Again";

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}

class Register extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      country: '',
      county: '',
      postcode: '',
      phoneNumber: '',
      alert: _.clone(emptyAlert),
      pictureTaken: false,
      image: ''
    }
    this.webcamRef = React.createRef();

  }

  takePicture = () => {
    if (this.state.image === '') {
      if (!this.webcamRef.current) return;
      const imageSrc = this.webcamRef.current.getScreenshot();
      if (!imageSrc) return;
      this.convert(imageSrc)
    } else {
      this.setState({ image: '' })
    }
  }

  convert = (data) => {
    if (!data) return;
    var image = new Image();

    image.onload = () => {
      const width = image.width;
      const height = image.height;
      if (!width || !height) return;

      var canvas = document.createElement("canvas");
      const x = (width - height) / 2;

      canvas.width = height;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, x, 0, height, height, 0, 0, height, height);
      this.setState({ image: canvas.toDataURL("image/png") })
    };

    image.src = data;
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  submit = async () => {
    var image;
    const domain = config.serverURL;
    let token = JSON.parse(window.localStorage.getItem('userData')).token;

    if (this.isFormValid()) {
      if (this.state.image !== '') {
        try {
          const url = domain + '/ImageUploads/wackykingdom/upload' + '?access_token=' + token;
          var ImageURL = this.state.image
          var block = ImageURL.split(";");
          var contentType = block[0].split(":")[1];
          var realData = block[1].split(",")[1];

          var blob = this.b64toBlob(realData, contentType);
          var formDataToUpload = new FormData();
          var filename = this.generateReferenceNumber('IMG') + '.png';
          formDataToUpload.append("file", blob, filename);

          const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
          }

          await axios.post(url, formDataToUpload, config);

          image = filename;
        } catch (error) {
          console.log('submit (uploading image) - error:', error.message);
        }
      }

      var data = _.clone(this.state)
      delete data['alert']
      delete data['image']
      delete data['shouldClose']
      delete data['pictureTaken']
      data.image = image;
      this.props.sendRequest(newUser, data)
    }
  }

  generateReferenceNumber = (prefix) => {
    var today = new Date();
    const year = today.getFullYear();
    var month = today.getMonth() + 1;
    if(month < 10) month = '0' + month;
    var day = today.getDate();
    if(day < 10) day = '0' + day;
    const randomNo = Math.floor((Math.random() * 900000) + 100000);

    return (prefix + year + month + day + randomNo);
  }

  b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  isFormValid = () => {
    var missingFields = []

    if (isBlank(this.state.firstName)) {
      missingFields.push('First Name');
    }
    if (isBlank(this.state.lastName)) {
      missingFields.push('Last Name');
    }
    if (isBlank(this.state.email)) {
      missingFields.push('Email');
    }
    if (isBlank(this.state.phoneNumber)) {
      missingFields.push('Phone Number');
    }

    if (missingFields.length === 0) {
      return true;
    }
    var message = ''
    if (missingFields.length === 1) {
      message = 'Field ' + missingFields[0] + ' is blank';
    } else {
      var last = missingFields.pop()
      message = 'Fields ' + missingFields.join(', ') + ' and ' + last + ' are blank';
    }

    var alert = {
      showAlert: true,
      message: message,
      type: 'warning',
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert })
    return false;
  }

  getText = () => {
    if (this.props.requestFailed) {
      return errorText;
    } else if (this.props.requestLoading) {
      return loadingText;
    } else {
      return registerText;
    }
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert}/>
    } else if (this.props.requestFailed) {
      var alert = _.clone(emptyAlert);
      alert.type = 'error';
      alert.showAlert = true;
      alert.message = tryAgainText;
      alert.callback = () => {
        this.props.changeFinished();
      }

      return <Alert alert={alert}/>
    } else if (this.props.requestFinished) {
      var alert2 = _.clone(emptyAlert);
      alert2.type = 'success';
      alert2.showAlert = true;
      alert2.callback = () => {
        if (this.props.userForBooking.required) {
          this.animateCloseOpen(true);
        } else {
          this.props.closeWindow();
        }
        this.props.changeFinished();
      }

      return <Alert alert={alert2}/>
    } else {
      return void(0)
    }
  }

  animateCloseOpen = (completed) => {
    var redirect = this.props.userForBooking.redirect;
    if (this.props.userForBooking.required && !completed)
      this.props.newUserNotRequired();
    this.setState({
      shouldClose: true
    }, () => {
      setTimeout(() => {
        this.props.closeOpenWindow(redirect)
      }, 500)
    })
  }

  animateClose = () => {
    if (this.props.userForBooking.required)
      this.props.newUserNotRequired();

    this.setState({
      shouldClose: true
    }, () => {
      setTimeout(() => {
        this.props.closeWindow()
      }, 500)
    })
  }

  render () {
    return (
      <div className={"registerWindow" + (this.state.shouldClose ? ' closeWindow' : '')}>
        <div className="registerForm">
          <IosCloseCircleOutline onClick={() => this.animateClose()} className="closeIcon" fontSize="30px" color="#fff" />
          {this.props.userForBooking.required ?
            <IosArrowRoundBack onClick={() => this.animateCloseOpen()} className="backIcon" fontSize="45px" color="#fff" /> : void(0)
          }
          <div className="titleText">{registerText}</div>
          {this.state.image === '' && <div className="videoWrapper">
            <Webcam
              width={200}
              height={200}
              audio={false}
              ref={this.webcamRef}
              screenshotFormat="image/png"
              minScreenshotWidth={640}
              minScreenshotHeight={480}
              videoConstraints={{ facingMode: 'user' }}
            />
          </div>}
          {this.state.image !== '' && <div className="videoWrapper avatarImage" style={{backgroundImage: "url('" + this.state.image +"')"}}></div>}
          <div className="takePicture">
            <div onClick={() => this.takePicture()} className="buttonWrapper">{this.state.image === '' ? takePictureText : takeAgainText}</div>
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.firstName}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('firstName', e)}
              placeholder={firstNameText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.lastName}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('lastName', e)}
              placeholder={lastNameText}
            />
          </div>
          <div className="formGap"/>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.email}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('email', e)}
              placeholder={emailText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.phoneNumber}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('phoneNumber', e)}
              placeholder={phoneText}
            />
          </div>
          <div className="formGap"/>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.address1}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('address1', e)}
              placeholder={addressOneText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.address2}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('address2', e)}
              placeholder={addressTwoText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.city}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('city', e)}
              placeholder={cityText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.county}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('county', e)}
              placeholder={countyText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.country}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('country', e)}
              placeholder={countryText}
            />
          </div>
          <div className="inputWrapper">
            <input
              type="text"
              value={this.state.postcode}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange('postcode', e)}
              placeholder={postcodeText}
            />
          </div>
          <div className="buttonWrapper" onClick={() => this.submit()}>
            {submitText}
          </div>
        </div>
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ users }) => ({
  recentUsers: users.recentUsers,
  requestFailed: users.requestFailed,
  userForBooking: users.userForBooking,
  requestLoading: users.requestLoading,
  requestFinished: users.requestFinished
})

const mapDispatchToProps = dispatch => bindActionCreators({ sendRequest, changeFinished, newUserNotRequired }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register)
